module["exports"] = [
  "kırmızı",
  "yeşil",
  "mavi",
  "sarı",
  "mor",
  "nane yeşili",
  "mavi",
  "beyaz",
  "siyah",
  "turuncu",
  "pembe",
  "gri",
  "bordo",
  "menekşe",
  "turkuaz",
  "tan",
  "gökyüzü mavisi",
  "somon",
  "erik",
  "orkide",
  "zeytin",
  "eflatun",
  "misket limonu",
  "fildişi",
  "indigo",
  "altın",
  "fuşya",
  "camgöbeği",
  "masmavi",
  "lavanta",
  "gümüş"
];
